/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const defaultOptions = {
    defaultStyle: "primary",
    defaultColour: "brand",
    defaultIcon: "none" 
};

export const styleOptions = [
    {
        displayTitle: "Filled (primary)",
        value: "primary"
    },
    {
        displayTitle: "Outlined (secondary)",
        value: "secondary"
    },
    {
        displayTitle: "Borderless (tertiary)",
        value: "tertiary"
    }
];

export const colourOptions = [
    {
        displayTitle: "Brand",
        value: "brand"
    },
    {
        displayTitle: "Neutral",
        value: "neutral"
    },
    {
        displayTitle: "Success",
        value: "success"
    },
    {
        displayTitle: "Error",
        value: "error"
    }
];

export const iconOptions = [
    {
        displayTitle: "None",
        value: "none"
    },
    {
        displayTitle: "Arrow",
        value: "arrow"
    },
    {
        displayTitle: "External",
        value: "external"
    }
];
